import HealthcareandMedical from '../../../../assets/images/Healthcare-and-Medical-Practices-icon.webp'
import LegalServices from '../../../../assets/images/Legal-Services-Attorneys-and-Law-Firms-icon.webp'
import RealEstate from '../../../../assets/images/Real-Estate-and-Realtors-icon.webp'
import RestaurantHospitality from '../../../../assets/images/Restaurant-and-Hospitality-icon.webp'
import ConstructionCompaniesContractors from '../../../../assets/images/Construction-Companies-and-Contractors-icon.webp'
import LogisticsTransportation from '../../../../assets/images/Logistics-and-Transportation-icon.webp'
import PhotographersCreators from '../../../../assets/images/Photographers-and-Creators-icon.webp'
import TravelTourism from '../../../../assets/images/Travel-and-Tourism-icon.webp'
import FitnessWellness from '../../../../assets/images/Fitness-and-Wellness-icon.webp'
import FinancialServices from '../../../../assets/images/Financial-Services-icon.webp'
import RetailBusinesses from '../../../../assets/images/Retail-Businesses-icon.webp'
import BeautyCosmetics from '../../../../assets/images/Beauty-and-Cosmetics-icon.webp'
import ManufacturingCompanies from '../../../../assets/images/Manufacturing-Companies-icon.webp'
import EducationalInstitutions from '../../../../assets/images/Educational-Institutions-icon.webp'
import NonprofitOrganizations from '../../../../assets/images/Non-profit_-Organizations-icon.webp'
import WeddingPlannersMatrimonialServices from '../../../../assets/images/Wedding-Planners-and-Matrimonial-Services-icon.webp'
import AutomotiveDealerships from '../../../../assets/images/Automotive-Dealerships-icon.webp'
import InsuranceAgencies from '../../../../assets/images/Insurance-Agencies-icon.webp'
import BeautySalonsSpas from '../../../../assets/images/Beauty-Salons-and-Spas-icon.webp'
import ConsultingFirms from '../../../../assets/images/Consulting-Firms-icon.webp'
export const lists = [
    {icon: HealthcareandMedical, text:'Healthcare and Medical Practices'},
    {icon:LegalServices , text:'Attorneys and Law Firms'},
    {icon:RealEstate , text:'Real Estate and Realtors'},
    {icon:RestaurantHospitality , text:'Restaurant and Hospitality '},
    {icon: ConstructionCompaniesContractors, text:'Construction  and Contractors '},
    {icon:LogisticsTransportation , text:'Logistics and Transportation'},
    {icon: PhotographersCreators, text:'Photographers and Creators'},
    {icon:TravelTourism , text:'Travel and Tourism'},
    {icon:FitnessWellness , text:'Fitness and Wellness '},
    {icon:FinancialServices , text:'Financial Services'},
    {icon:RetailBusinesses , text:'Retail Businesses'},
    {icon:BeautyCosmetics , text:'Beauty and Cosmetics '},
    {icon: ManufacturingCompanies, text:'Manufacturing Companies'},
    {icon:EducationalInstitutions , text:'Educational Institutions'},
     {icon: InsuranceAgencies, text:'Insurance Agencies'},
    {icon:BeautySalonsSpas , text:'Beauty Salons and Spas'},
    {icon:ConsultingFirms , text:'Consulting Firms'},
    {icon: NonprofitOrganizations , text:'Non-profit Organizations'},
    {icon: WeddingPlannersMatrimonialServices, text:'Wedding Planners and Matrimonials'},
    {icon: AutomotiveDealerships, text:'Automotive Dealerships'},
   
   

]